module.exports = __webpack_public_path__ + "img/blueprint-background.8d417af3.png";